export const columnLayout = (
  popVendorInfo,
  popRealVendorInfo,
  popLoadAreaInfo,
  popDepartureMap,
  popDepartureImage,
  popRoadTicketImage,
  popWeigtingCertificate
) => {
  const gridColumnLayOut = [
    {
      dataField: "systemCd",
      headerText: "회사구분",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantCd",
      headerText: "사업장구분",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "plantNm",
      headerText: "사업장",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "transStatusCd",
      headerText: "배차상태",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "transStatusCdNm",
      headerText: "배차상태",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      styleFunction: function (
        rowIndex,
        columnIndex,
        value,
        headerText,
        item,
        dataField
      ) {
        if (item.transStatusCd === "T" || item.transStatusCd === "R") {
          return "my-cell-style1";
        } else if (item.transStatusCd === "D") {
          return "my-cell-style2";
        } else if (item.transStatusCd === "A") {
          return "my-cell-style3";
        } else if (item.transStatusCd === "W") {
          return "my-cell-style4";
        } else if (item.transStatusCd === "S" || item.transStatusCd === "I") {
          return "my-cell-style5";
        }
        return null;
      },
    },
    {
      dataField: "vndrCd",
      headerText: "공급업체 코드",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vndrNm",
      headerText: "공급업체",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "LinkRenderer",
        baseUrl: "javascript", // 자바스크립 함수 호출로 사용하고자 하는 경우에 baseUrl 에 "javascript" 로 설정
        // baseUrl 에 javascript 로 설정한 경우, 링크 클릭 시 callback 호출됨.
        jsCallback: function (rowIndex, columnIndex, value, item) {
          popVendorInfo(item);
        },
      },
    },
    {
      dataField: "tmsOdrNo",
      headerText: "배차번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "wghtDt",
      headerText: "입고일자",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo",
      headerText: "차량번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "vhclNo4",
      headerText: "차량번호 4자리",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "preItemCd",
      headerText: "사전등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivNm",
      headerText: "운전자",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "drivTel",
      headerText: "전화번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtAddr",
      headerText: "출발보고위치",
      width: 250,
      style: "my-left-column",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "LinkRenderer",
        baseUrl: "javascript", // 자바스크립 함수 호출로 사용하고자 하는 경우에 baseUrl 에 "javascript" 로 설정
        // baseUrl 에 javascript 로 설정한 경우, 링크 클릭 시 callback 호출됨.
        jsCallback: function (rowIndex, columnIndex, value, item) {
          popDepartureMap(item);
        },
      },
    },
    {
      dataField: "dprtAddrLvl01",
      headerText: "출발보고 주소레벨1",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtAddrLvl02",
      headerText: "출발보고 주소레벨2",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtLatt",
      headerText: "출발보고위치위도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtLont",
      headerText: "출발보고위치경도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtVhcl01Latt",
      headerText: "출발보고사진1위도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtVhcl01Lont",
      headerText: "출발보고사진1경도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtVhcl02Latt",
      headerText: "출발보고사진2위도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtVhcl02Lont",
      headerText: "출발보고사진2경도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "rvndrCd",
      headerText: "실공급업체 코드",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "rvndrNm",
      headerText: "실공급업체",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "LinkRenderer",
        baseUrl: "javascript", // 자바스크립 함수 호출로 사용하고자 하는 경우에 baseUrl 에 "javascript" 로 설정
        // baseUrl 에 javascript 로 설정한 경우, 링크 클릭 시 callback 호출됨.
        jsCallback: function (rowIndex, columnIndex, value, item) {
          popRealVendorInfo(item);
        },
      },
    },
    {
      dataField: "loadAreaCd",
      headerText: "상차지 코드",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "loadAreaNm",
      headerText: "상차지명",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "LinkRenderer",
        baseUrl: "javascript", // 자바스크립 함수 호출로 사용하고자 하는 경우에 baseUrl 에 "javascript" 로 설정
        // baseUrl 에 javascript 로 설정한 경우, 링크 클릭 시 callback 호출됨.
        jsCallback: function (rowIndex, columnIndex, value, item) {
          popLoadAreaInfo(item);
        },
      },
    },
    {
      dataField: "loadLatt",
      headerText: "상차지위도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "loadLont",
      headerText: "상차지경도",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },

    {
      dataField: "arrvDt",
      headerText: "도착보고시간",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "itemEtc",
      headerText: "비고",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "scalNumb",
      headerText: "계근번호",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inWgtDt",
      headerText: "입차일시",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outWgtDt",
      headerText: "출차일시",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "inWgt",
      headerText: "입차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "outWgt",
      headerText: "출차중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "wtredtCd",
      headerText: "감량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "reduceNm",
      headerText: "감량사유",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "realWgt",
      headerText: "입고중량",
      dataType: "numeric",
      formatString: "#,##0",
      style: "my-custom-right",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "cnfGrd",
      headerText: "검수등급",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtDt",
      headerText: "출발보고 일시",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "tmapApiDistance",
      headerText: "TMAP 거리",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "dprtDistance",
      headerText: "출발보고 거리",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
    },
    {
      dataField: "startImg",
      headerText: "출발보고사진",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "사진",
        onClick: popDepartureImage,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          // 행 아이템의 name 이 운송상태가 등록으로 되어 있으면  라면 버튼 표시
          if (
            item.transStatusCd === "D" ||
            item.transStatusCd === "A" ||
            item.transStatusCd === "W" ||
            item.transStatusCd === "I" ||
            item.transStatusCd === "G" ||
            item.transStatusCd === "S"
          ) {
            return true;
          }
          return false;
        },
      },
    },
    {
      dataField: "wgtView",
      headerText: "계근표",
      visible: false,
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "계근표",
      },
    },
    {
      dataField: "roadTicket",
      headerText: "도로영수증",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "도로영수증",
        onClick: popRoadTicketImage,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          // 행 아이템의 name 이 운송상태가 등록으로 되어 있으면  라면 버튼 표시
          if (
            item.transStatusCd === "A" ||
            item.transStatusCd === "W" ||
            item.transStatusCd === "I" ||
            item.transStatusCd === "G" ||
            item.transStatusCd === "S"
          ) {
            return true;
          }
          return false;
        },
      },
    },
    /*
    {
      dataField: "WeigtingCertificate",
      headerText: "계량증명서",
      filter: {
        showIcon: true,
        useExMenu: true,
      },
      renderer: {
        type: "ButtonRenderer",
        labelText: "계량증명서",
        onClick: popWeigtingCertificate,
        visibleFunction: function (
          rowIndex,
          columnIndex,
          value,
          item,
          dataField
        ) {
          if (item.transStatusCd === "S") {
            return true;
          }
          return false;
        },
      },      
    },
    */
  ];
  return gridColumnLayOut;
};
